module.exports = __webpack_public_path__ + "img/icon_snapsheet.447257c7.svg";